import { IAttachmentFile } from '../HBFilesThumbnails';
import { generatePdfThumbnailUrl } from '../../common/image.utils';

const DEFAULT_ICON_URL =
    '//res.cloudinary.com/honeybook/image/upload/v1502008386/system_web/rebranding/file-default.svg';
const EXCEL_ICON_URL =
    '//res.cloudinary.com/honeybook/image/upload/v1501764251/system_web/rebranding/file_icon_xls.svg';
const DOC_ICON_URL =
    '//res.cloudinary.com/honeybook/image/upload/v1501764251/system_web/rebranding/file_icon_doc.svg';
const PDF_ICON_URL =
    '//res.cloudinary.com/honeybook/image/upload/v1501764252/system_web/rebranding/file_icon_pdf.svg';

export const getFileIcon = ({ name, type, url }: IAttachmentFile): string => {
    let iconUrl = DEFAULT_ICON_URL;
    const safeType = type || '';
    if (!name) {
        return iconUrl;
    }

    if (name.match(/xlsx?$/) || safeType.match(/xlsx?$/)) {
        iconUrl = EXCEL_ICON_URL;
    } else if (name.match(/docx?$/) || safeType.match(/docx?$/)) {
        iconUrl = DOC_ICON_URL;
    } else if (url && (name.match(/pdf$/) || safeType.match(/pdf$/))) {
        if (url) {
            iconUrl = generatePdfThumbnailUrl({ url, width: 100, height: 58 });
        } else {
            iconUrl = PDF_ICON_URL;
        }
    }

    return iconUrl;
};
